import React from "react";
import dayjs from "dayjs";
import FashionTillShell from "./FashionTillShell";
import FashionDenomGrid from "./FashionDenomGrid";
import { formatTillMoney, tillAmountValue } from "./tillFormat";

// Board open-count: count notes and coins to open the till.
const FashionOpenCount = ({
  outlet,
  till,
  currency,
  denominations,
  totalAmount,
  lastCloseAmount,
  noteValue,
  setNoteValue,
  onFieldInput,
  onFieldOut,
  onFieldButton,
  onClearAll,
  onOpenTill,
  onBack,
  isExecuting,
  confirmBtnRef,
}) => {
  const opening = tillAmountValue(totalAmount);
  const hasLastClose = lastCloseAmount !== undefined && lastCloseAmount !== null && lastCloseAmount !== "";
  const lastClose = tillAmountValue(lastCloseAmount);
  const diff = Math.round((opening - lastClose) * 100) / 100;
  const meta = [till, outlet].filter(Boolean).join(" · ");
  return (
    <FashionTillShell title="Open till" meta={meta} onBack={onBack} testId="fashion-open-count">
      <section className="ftill-main">
        <div className="ftill-main__head">
          <div>
            <h1 className="ftill-h1">Count the cash in the drawer</h1>
            <p className="ftill-sub">Enter how many notes and coins of each value you have.</p>
          </div>
          <button type="button" className="ftill-btn ftill-btn--secondary ftill-btn--sm" onClick={onClearAll}>
            Clear all
          </button>
        </div>
        <FashionDenomGrid denominations={denominations} currency={currency} onFieldInput={onFieldInput} onFieldOut={onFieldOut} onFieldButton={onFieldButton} />
      </section>
      <aside className="ftill-side">
        <div className="ftill-total">
          <span className="ftill-total__label">Opening cash</span>
          <b className="ftill-total__value">{formatTillMoney(opening, currency)}</b>
        </div>
        {hasLastClose ? (
          <div className="ftill-row">
            <span>Left in drawer at last close</span>
            <b>{formatTillMoney(lastClose, currency)}</b>
          </div>
        ) : null}
        {hasLastClose && diff !== 0 ? (
          <div className="ftill-warn" role="status">
            {formatTillMoney(Math.abs(diff), currency)} {diff > 0 ? "more" : "less"} than last close. Add a note if this is expected.
          </div>
        ) : null}
        <div className="ftill-field">
          <label className="ftill-label" htmlFor="ftill-open-note">
            Note
          </label>
          <input
            id="ftill-open-note"
            className="ftill-input"
            placeholder="e.g. Float topped up by manager"
            value={noteValue}
            onChange={(e) => setNoteValue(e.target.value)}
          />
        </div>
        <div className="ftill-grow" />
        <div className="ftill-foot-meta">{[outlet, till, dayjs().format("ddd D MMM, HH:mm")].filter(Boolean).join(" · ")}</div>
        <button type="button" ref={confirmBtnRef} className="ftill-btn ftill-btn--go ftill-btn--lg" disabled={isExecuting} onClick={onOpenTill}>
          Open till
        </button>
      </aside>
    </FashionTillShell>
  );
};

export default FashionOpenCount;
